import {
  mdiAccountGroup,
  mdiAccountMultipleOutline,
  mdiAccountPlus,
  mdiAlertOutline,
  mdiWrenchOutline,
  mdiAlphaSCircleOutline,
  mdiApi,
  mdiBook,
  mdiBookOpenPageVariant,
  mdiCalendarClock,
  mdiCar,
  mdiCartPlus,
  mdiClipboardTextClockOutline,
  mdiCloudPrint,
  mdiCollage,
  mdiCurrencyInr,
  mdiChartBar,
  mdiChartLine,
  mdiFileDocument,
  mdiFileMultiple,
  mdiFormatListCheckbox,
  mdiHistory,
  mdiHome,
  mdiHuman,
  mdiInboxFull,
  mdiPackageVariantClosed,
  mdiPackageVariantClosedCheck,
  mdiPostOutline,
  mdiShieldKey,
  mdiShieldPlus,
  mdiShoppingOutline,
  mdiSwapHorizontal,
  mdiTextBoxMultipleOutline,
  mdiTextBoxPlusOutline,
  mdiToolboxOutline,
  mdiTrayArrowUp,
  mdiTruckOutline,
  mdiViewDashboard,
  mdiWarehouse,
} from "@mdi/js";
import Icon from "@mdi/react";
import { ACTION, MODULE } from "./enums";
import axios from "axios";

const root = "/";

export let urls = {
  root: `${root}`,
  orderList: `${root}orders`,
  customers: `${root}customers`,
  create_customer: `${root}customers/create`,
  customer_detail: `${root}customers/detail`,
  dashboard: `${root}dashboard`,
  login: `${root}login`,
  logout: `${root}logout`,
  notAllowed: `${root}not-allowed`,
  users: `${root}users`,
  sessionLogs: `${root}access-panel/session-logs`,
  roles: `${root}access-panel/roles`,
  createRole: `${root}access-panel/create-role`,
  editRole: `${root}access-panel/edit-role`,
  userEdit: `${root}access-panel/edit-detail`,
  userCreate: `${root}access-panel/user-create`,
  createOrder: `${root}create-order`,
  bulkCreateOrder: `${root}bulk-create-order`,
  orderDetail: `${root}order-detail`,
  transaction: `${root}transaction`,
  invoice: `${root}invoice`,
  transactionDetail: `${root}transaction-detail`,
  test: `${root}test`,
  kpi_dash: `${root}kpi-dash`,
  complaints: `${root}complaints`,
  create_complaint: `${root}complaints/create`,
  complaint_detail: `${root}complaints/detail`,
  service_desk_tracker: `${root}complaints/service_desk_tracker`,
  complaint_word_cloud: `${root}complaints/word_cloud`,
  compliant_insights: `${root}complaints/complaint-insights`,
  inventory_overview: `${root}inventory/overview`,
  installed_device: `${root}installed_device`,
  device_alloction: `${root}device_allocation`,
  ops_tasks: `${root}ops_tasks`,
  ops_tickets: `${root}ops_tickets`,
  emp_basket: `${root}emp_basket`,
  operation_task: `${root}operation-tasks`,
  operation_engineer_task: `${root}operation/engineer/tasks`,
  my_operation_task: `${root}my_operation_task`,
  my_recent_operation_task: `${root}my_recent_operation_task`,
  my_operation_task_detail: `${root}my_operation_task/detail`,
  emp_attendance: `${root}my_operation_task/attendance`,
  emp_attendace_history: `${root}my_operation_task/attendace_history`,
  ops_task_session: `${root}operation_task/sessions`,
  ops_admin_view: `${root}operation/admin`,

  hrm_home: `${root}hrm/home`,
  ai_agent: `${root}ai-agent/home`,
  hrm_leave_application: `${root}hrm/leave-application`,
  hrm_overview: `${root}hrm/overview`,
  hrm_dept: `${root}hrm/departments`,
  hrm_dept_emp: `${root}hrm/departments/:dept`,
  hrm_sub_dept_emp: `${root}hrm/employeeList/:dept/:subdept`,
  hrm_all_emp: `${root}hrm/employeeList/:dept/all`,
  hrm_my_profile: `${root}hrm/my-profile`,
  hrm_profile: `${root}hrm/profile/detail`,
  hrm_gmc: `${root}hrm/profile/gmc/:uid`,
  hrm_docs: `${root}hrm/profile/docs/:uid`,
  hrm_my_docs: `${root}hrm/profile/my-docs/:uid`,
  hrm_pf: `${root}hrm/profile/pf/:uid`,
  hrm_personalInfo: `${root}hrm/profile/personal-info/:uid`,
  hrm_leaves: `${root}hrm/profile/leaves/:uid`,
  hrm_leaves_edit: `${root}hrm/profile/edit-leaves`,
  hrm_leave_data: `${root}hrm/leave-data`,
  hrm_birthday: `${root}hrm/birthday`,
  hrm_work_anniversary: `${root}hrm/work-anniversary`,
  hrm_policies: `${root}hrm/policies`,
  hrm_gmc_policy: `${root}hrm/gmc-policy`,
  hrm_files_upload: `${root}hrm/files-upload`,
  hrm_organization_tree: `${root}hrm/organization-tree`,
  hrm_memories: `${root}hrm/memories`,
  hrm_memories_view: `${root}hrm/memories-view`,
  hrm_org_tree_tab: `${root}hrm/org-tree-tab`,
  hrm_hr_leave_record: `${root}hrm/create-leave_record`,
  hrm_hr_leave_panel: `${root}hrm/hr-leave-panel`,
  hrm_job_portal: `${root}hrm/job-portal`,
  hrm_create_job: `${root}hrm/create-job`,
  hrm_add_employee: `${root}hrm/add_employee`,
  hrm_apply_job: `${root}hrm/apply-job/:id/:ref_id`,
  hrm_job_applicants: `${root}hrm/job-applicants`,
  hrm_job_applicants_view: `${root}hrm/job-applicants-view/:id`,
  hrm_analytics: `${root}hrm/analytics`,
  hrm_employee_map: `${root}hrm/analytics/employee-map`,

  master_data: `${root}master-data`,
  master_data_warehouse: `${root}master-data/warehouse`,
  master_data_warehouse_create: `${root}master-data/warehouse/create`,
  master_data_warehouse_update: `${root}master-data/warehouse/update`,

  kazam_academy: `${root}kazam-academy`,
  protocol_category: `${root}kazam-academy/protocol-category`,
  videos_category: `${root}kazam-academy/videos-category`,
  upload_academy: `${root}kazam-academy/upload-video`,
  saved_videos: `${root}kazam-academy/saved-videos`,
  watched_videos: `${root}kazam-academy/watched-videos`,
  installation_protocol: `${root}kazam-academy/installation-protocol`,
  saas_protocol: `${root}kazam-academy/saas-protocol`,
  complaint_segment: `${root}kazam-academy/complaint-segment`,
  complaint_protocol: `${root}kazam-academy/complaint-segment/complaint-protocol`,
  inside_sales_protocol: `${root}kazam-academy/inside-sales-protocol`,
  sales_training_protocol: `${root}kazam-academy/sales-training-protocol`,
  hub_creation_checklist: `${root}kazam-academy/hub-creation-checklist`,
  kazam_warranty: `${root}kazam-academy/kazam-warranty`,
  safety_protocols: `${root}kazam-academy/safety-protocols`,
  starter_pack: `${root}kazam-academy/starter-pack`,
  brochure_starter: `${root}kazam-academy/brochure-starter`,
  digital_background_starter: `${root}kazam-academy/digital-background-starter`,
  emailer_deck_starter: `${root}kazam-academy/emailer-deck-starter`,
  id_card_starter: `${root}kazam-academy/id-card-starter`,
  sticker_starter: `${root}kazam-academy/sticker-starter`,
  google_meet_background: `${root}kazam-academy/google-meet-background`,
  linkedin_banner: `${root}kazam-academy/linkedin-banner`,

  kazam_learning: `${root}kazam-academy/kazam-learning`,
  general_learning: `${root}kazam-academy/videos/general`,
  cms_learning: `${root}kazam-academy/kazam-learning/cms`,
  podcast_learning: `${root}kazam-academy/kazam-learning/podcasts`,
  ev_news: `${root}kazam-academy/kazam-learning/ev-news`,
  ev_reviews: `${root}kazam-academy/kazam-learning/ev-reviews`,
  tally_learning: `${root}kazam-academy/kazam-learning/tally`,
  sales_learning: `${root}kazam-academy/kazam-learning/sales`,
  company_updates: `${root}kazam-academy/kazam-learning/company-updates`,
  hr_policies: `${root}kazam-academy/kazam-learning/hr-policies`,
  life_at_kazam: `${root}kazam-academy/kazam-learning/life-at-kazam`,
  startup_gyaan: `${root}kazam-academy/kazam-learning/startup-gyaan`,
  success_story: `${root}kazam-academy/kazam-learning/success-stories`,
  api_client_list: `${root}api-clients/all`,
  api_client_my_list: `${root}api-clients`,
  content_panel: `${root}content-panel`,
  warehouse_panel: `${root}warehouse-panel`,
  warehouse_dashboard: `${root}warehouse-panel/warehouse-dashboard`,
  warehouse_inward: `${root}warehouse-panel/inward`,
  warehouse_team: `${root}warehouse-team`,
  warehouse_inventory: `${root}warehouse-team/inventory`,
  warehouse_stock_ledger: `${root}warehouse-team/stock-ledger`,
  warehouse_quarantine: `${root}warehouse-team/quarantine`,
  warehouse_faulty_resolution: `${root}warehouse-team/faulty-resolution`,
  warehouse_logs: `${root}warehouse-panel/warehouse-logs`,

  request_desk_list: `${root}request-desk`,
  raise_request: `${root}request-desk/raise`,
  request_desk_detail: `${root}request-desk/view`,
  request_desk_fault_dashboard: `${root}request-desk/fault-dashboard`,

  Dashboard: `${root}Dashboard`,

  blogCreate: `${root}content-panel/blogs/create`,
  blogUpdate: `${root}content-panel/blogs/update`,
  blogListing: `${root}content-panel/blogs`,
  uploadImage: `${root}content-panel/upload-image`,

  installation: `${root}content-panel/installation`,
  installationCreate: `${root}content-panel/installation-create`,
  installationEdit: `${root}content-panel/installation-editor`,

  vehicleListing: `${root}content-panel/vehicle-listings`,
  vehicleCreate: `${root}content-panel/vehicle-listings/create`,
  bikeSpec: `${root}content-panel/vehicle-listings/bike/specifications/:id`,
  bikePricing: `${root}content-panel/vehicle-listings/bike/pricing/:id`,
  bikeImages: `${root}content-panel/vehicle-listings/bike/images/:id`,
  authors: `${root}content-panel/authors`,
  authorCreate: `${root}content-panel/author-create`,
  authorEdit: `${root}content-panel/author-edit`,
  vehicles: `${root}content-panel/vehicles`,
  varientListing: `${root}content-panel/vehicles/varients`,
  priceListing: `${root}content-panel/vehicles/varients/prices`,
  galleryListing: `${root}content-panel/vehicles/varients/gallery`,

  ev: `${root}content-panel/ev`,

  createVehicle: `${root}content-panel/create-vehicle`,
  updateVehicle: `${root}content-panel/update-vehicle`,
  gallery: `${root}content-panel/gallery`,

  procurement: `${root}procurement`,
  // procurement_masters: `${root}procurement/masters`,
  procurement_masters_warehouse: `${root}procurement/masters`,
  project_master: `${root}procurement/masters/project`,
  procurement_masters_party: `${root}procurement/masters/party`,
  procurement_masters_gst: `${root}procurement/masters/gst`,
  procurement_masters_item: `${root}procurement/masters/item`,
  procurement_masters_cost_center: `${root}procurement/masters/cost-center`,
  procurement_masters_transform: `${root}procurement/masters/transform`,
  business_unit: `${root}masters/business-unit`,
  department: `${root}masters/department`,
  // Phase 7C — EAF bulk-edit of BU/Dept planning cadence
  budget_cadence: `${root}masters/budget-cadence`,
  // Phase 8 — MIS module
  mis_root: `${root}mis`,
  mis_list: `${root}mis/list`,
  mis_view: `${root}mis/view`, // /:id appended by consumer
  mis_grid: `${root}mis/grid`, // /:id appended by consumer
  // Phase 6 — dashboards
  dashboards_root: `${root}dashboards`,
  cc_dashboard: `${root}dashboards/cc`,
  bu_dashboard: `${root}dashboards/bu`,
  dept_dashboard: `${root}dashboards/dept`,
  finance_dashboard: `${root}dashboards/finance`,
  matrix_dashboard: `${root}dashboards/matrix`,
  procurement_dashboard: `${root}dashboards/procurement`,
  procurement_masters_item_unit: `${root}procurement/masters/item_unit`,
  procurement_masters_po_report: `${root}procurement/masters/po-report`,

  purchase_voucher: `${root}procurement/vouchers/purchase-voucher`,
  purchase_service_voucher: `${root}procurement/vouchers/purchase-service-voucher`,

  stock_transfer: `${root}procurement/stock-transfer`,
  stock_outward: `${root}procurement/stock-outward`,
  npd: `${root}procurement/new-product-development`,
  inventory_home: `${root}inventory`,
  closing_stock: `${root}inventory/closing-stock`,
  bulk_stock_upload: `${root}inventory/bulk-stock-upload`,
  inventory_audit_stock_logs: `${root}inventory/stock-audit-logs`,
  stock_action_requests: `${root}inventory/stock-requests`,
  stock_action_request_edit: `${root}inventory/stock-requests/:id/edit`,
  device_inventory: `${root}inventory/device-inventory`,
  prev_device_inventory: `${root}inventory/prev-device-inventory`,

  inventory_tracker: `${root}inventory/montly-inventory-tracker`,
  in_transit_inventory: `${root}inventory/in-transit-inventory`,
  purchase_order: `${root}procurement/purchase-order`,
  procurement_project: `${root}procurement/project`,
  po_advance_payment_request: `${root}procurement/payment-request/payment-request`,
  po_payment_request_approval: `${root}procurement/payment-request/approval`,

  purchase_order_prev: `${root}procurement/purchase-order-prev`,
  procurement_masters_item_prev: `${root}procurement/masters/item-prev`,
  procurement_masters_party_prev: `${root}procurement/masters/party-prev`,
  po_advance_payment_request_prev: `${root}procurement/payment-request/payment-request-prev`,
  po_payment_request_approval_prev: `${root}procurement/payment-request/approval-prev`,
  customer_master: `${root}customer-master`,
  case_study: `${root}content-panel/case-study`,
  access_guide: `${root}access-guide`,
  user_role: `${root}user-role`,
};

export let new_erp_urls = {
  sop_home: `${process.env.REACT_APP_NEW_ERP_URL}/:temp-token?redirect=sop`,
  order_home: `${process.env.REACT_APP_NEW_ERP_URL}/:temp-token?redirect=orders`,
  knowledge_management_home: `${process.env.REACT_APP_NEW_ERP_URL}/:temp-token?redirect=knowledge-management`,
};

export const getRedirectUrl = async (module: string) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/auth/generate-temp-token`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        withCredentials: true,
      },
    );

    if (res.status !== 200) throw new Error("Failed to generate token");

    const token = res.data.tempToken;

    return `${process.env.REACT_APP_NEW_ERP_URL}/:temp-token?redirect=${module}`.replace(
      ":temp-token",
      token,
    );
  } catch (error) {
    throw error;
  }
};

export let omnichannel_url = `${process.env.REACT_APP_OMNICHANNEL_URL}/auth/callback?redirect=/`;

export const getOmniChannelRedirectUrl = async (dest: string) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/auth/generate-temp-token`,
      // target makes the backend mint an aud:'omnichannel' 5m token for resolve-temp-token
      { target: "omnichannel" },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        withCredentials: true,
      },
    );
    console.log("omnichannel_url :", omnichannel_url);
    console.log("getOmniChannelRedirectUrl : ", res.data);

    if (res.status !== 200) throw new Error("Failed to generate token");

    const token = res.data.tempToken;

    return `${process.env.REACT_APP_OMNICHANNEL_URL}/auth/callback?token=${token}&redirect=${encodeURIComponent(dest)}`;
  } catch (error) {
    throw error;
  }
};

export interface SideBarBtn {
  url?: string;
  lable: string;
  tag?: string;
  Icon?: any;
  module?: string;
  action: string[];
  operator?: "or" | "and";
  menu?: SideBarBtn[];
}

export const menuUrls = (mod?: string): SideBarBtn[] => {
  if (!mod) return [];
  switch (mod) {
    case MODULE.request_desk_panel:
      return [
        {
          url: urls.root,
          lable: "Main menu",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,
          action: [ACTION.READ],
        },
        {
          url: urls.raise_request,
          lable: "Raise Request",
          Icon: <Icon path={mdiWrenchOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.request_desk,
          action: [ACTION.CREATE],
        },
        {
          url: urls.request_desk_list,
          lable: "Requests",
          Icon: <Icon path={mdiFormatListCheckbox} className="h-5 w-5 mx-2" />,
          module: MODULE.request_desk,
          action: [ACTION.READ],
        },
        {
          url: urls.request_desk_fault_dashboard,
          lable: "Fault Dashboard",
          Icon: (
            <Icon
              path={mdiClipboardTextClockOutline}
              className="h-5 w-5 mx-2"
            />
          ),
          module: MODULE.request_desk_fault_dashboard,
          action: [ACTION.READ],
        },
      ];
    case MODULE.order_panel:
      return [
        {
          url: urls.root,
          lable: "Main menu",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,
          action: [ACTION.READ],
        },
        {
          url: urls.orderList,
          lable: "Orders",
          Icon: <Icon path={mdiShoppingOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.order,
          action: [ACTION.READ],
        },
        {
          url: urls.createOrder,
          lable: "Create Orders",
          Icon: <Icon path={mdiCartPlus} className="h-5 w-5 mx-2" />,
          module: MODULE.order,
          action: [ACTION.CREATE],
        },
        {
          url: urls.bulkCreateOrder,
          lable: "Bulk Create Orders",
          Icon: <Icon path={mdiTrayArrowUp} className="h-5 w-5 mx-2" />,
          module: MODULE.order,
          action: [ACTION.CREATE],
        },
        {
          url: urls.customer_master,
          lable: "Customer",
          Icon: <Icon path={mdiHuman} className="h-5 w-5 mx-2" />,
          module: MODULE.customer_master,
          action: [ACTION.READ],
        },
      ];

    case MODULE.device_inventory_panel:
      return [
        {
          url: urls.inventory_home,
          lable: "Home",
          module: MODULE.device_inventory_panel,
          action: [ACTION.READ],
        },
        {
          lable: "Closing Stock",
          module: MODULE.device_inventory_panel,
          action: [ACTION.READ],
          url: urls.closing_stock,
        },
        {
          lable: "Device Inventory",
          module: MODULE.device_inventory_panel,
          action: [ACTION.READ],
          url: urls.device_inventory,
        },
        {
          lable: "In-Transit Inventory",
          module: MODULE.device_inventory_panel,
          action: [ACTION.READ],
          url: urls.in_transit_inventory,
        },
        {
          lable: "Material Planning",
          module: MODULE.device_inventory_panel,
          action: [ACTION.READ],
          url: urls.inventory_tracker,
        },
        {
          lable: "Stock Requests",
          module: MODULE.audit_stock_upload,
          action: [ACTION.READ],
          url: urls.stock_action_requests,
        },
        {
          lable: "Stock Audit Logs",
          module: MODULE.device_inventory_panel,
          action: [ACTION.READ],
          url: urls.inventory_audit_stock_logs,
        },
        {
          lable: "Previous Device Inventory",
          module: MODULE.device_inventory_panel,
          action: [ACTION.READ],
          url: urls.prev_device_inventory,
        },
      ];
    case MODULE.access_guide:
      return [
        {
          url: urls.root,
          lable: "Main menu",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,

          action: [ACTION.READ],
        },
        {
          url: urls.access_guide,
          lable: "Access Guide",
          Icon: <Icon path={mdiAccountGroup} className="h-5 w-5 mx-2" />,
          module: MODULE.access_guide,
          action: [ACTION.READ],
        },
      ];
    case MODULE.access_panel:
      return [
        {
          url: urls.root,
          lable: "Main menu",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,

          action: [ACTION.READ],
        },
        {
          url: urls.users,
          lable: "Users",
          Icon: <Icon path={mdiAccountGroup} className="h-5 w-5 mx-2" />,
          module: MODULE.emp,
          action: [ACTION.READ, ACTION.CREATE],
        },
        {
          url: urls.userCreate,
          lable: "Create User",
          Icon: <Icon path={mdiAccountPlus} className="h-5 w-5 mx-2" />,
          module: MODULE.emp,
          action: [ACTION.CREATE],
        },
        {
          url: urls.sessionLogs,
          lable: "Session Logs",
          Icon: <Icon path={mdiHistory} className="h-5 w-5 mx-2" />,
          module: MODULE.emp,
          action: [ACTION.READ],
          tag: "New",
        },
        {
          url: urls.roles,
          lable: "Roles / Permissions",
          Icon: <Icon path={mdiShieldKey} className="h-5 w-5 mx-2" />,
          module: MODULE.role,
          action: [ACTION.READ, ACTION.CREATE],
        },
        {
          url: urls.createRole,
          lable: "Create Role",
          Icon: <Icon path={mdiShieldPlus} className="h-5 w-5 mx-2" />,
          module: MODULE.role,
          action: [ACTION.CREATE],
        },
        {
          url: urls.user_role,
          lable: "Role-User",
          Icon: <Icon path={mdiAccountGroup} className="h-5 w-5 mx-2" />,
          module: MODULE.user_role,
          action: [ACTION.READ],
          tag: "New",
        },
        {
          url: urls.api_client_list,
          lable: "Api Clients",
          Icon: <Icon path={mdiApi} className="h-5 w-5 mx-2" />,
          module: MODULE.api_master,
          action: [ACTION.DELETE],
        },
      ];

    case MODULE.SOP:
      return [
        {
          url: new_erp_urls.sop_home,
          lable: "Home",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,
          module: MODULE.SOP,
          action: [ACTION.READ],
        },
      ];

    case MODULE.knowledge_management:
      return [
        {
          url: new_erp_urls.knowledge_management_home,
          lable: "Home",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,
          module: MODULE.knowledge_management,
          action: [ACTION.READ],
        },
      ];

    case MODULE.complaint_panel:
      return [
        {
          url: urls.root,
          lable: "Main menu",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,

          action: [ACTION.READ],
        },
        {
          url: urls.complaints,
          lable: "Complaints",
          Icon: (
            <Icon path={mdiTextBoxMultipleOutline} className="h-5 w-5 mx-2" />
          ),
          module: MODULE.complaint,
          action: [ACTION.READ],
        },
        {
          url: urls.create_complaint,
          lable: "Create Complaint",
          Icon: <Icon path={mdiTextBoxPlusOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.complaint,
          action: [ACTION.CREATE],
        },
        {
          url: urls.service_desk_tracker,
          lable: "Service Desk Tracker",
          Icon: (
            <Icon
              path={mdiClipboardTextClockOutline}
              className="h-5 w-5 mx-2"
            />
          ),
          module: MODULE.complaint,
          action: [ACTION.CREATE],
        },
        {
          url: urls.complaint_word_cloud,
          lable: "Word cloud",
          Icon: <Icon path={mdiCloudPrint} className="h-5 w-5 mx-2" />,
          module: MODULE.complaint,
          action: [ACTION.CREATE],
        },
        {
          url: urls.complaint_segment,
          lable: "Protocol",
          Icon: <Icon path={mdiFileMultiple} className="h-5 w-5 mx-2" />,
          module: MODULE.complaint,
          action: [ACTION.READ],
        },
        {
          url: urls.compliant_insights,
          lable: "Complaint Insights",
          Icon: <Icon path={mdiInboxFull} className="h-5 w-5 mx-2" />,
          module: MODULE.complaint,
          action: [ACTION.READ],
        },
      ];
    case MODULE.hrm_panel:
      return [
        {
          url: urls.hrm_home,
          lable: "Home",
          Icon: <Icon path={mdiAlphaSCircleOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.hrm_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.hrm_overview,
          lable: "Overview",
          Icon: <Icon path={mdiAlphaSCircleOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.hrm_leave,
          action: [ACTION.READ],
        },
        {
          url: urls.hrm_dept,
          lable: "Employees",
          Icon: <Icon path={mdiAlphaSCircleOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.hrm_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.hrm_profile,
          lable: "Profile",
          Icon: <Icon path={mdiAlphaSCircleOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.hrm_panel,
          action: [ACTION.READ],
        },
      ];

    case MODULE.ops_task_panel:
      return [
        {
          url: urls.ops_admin_view,
          lable: "Dashboard",
          Icon: <Icon path={mdiViewDashboard} className="h-5 w-5 mx-2" />,
          module: MODULE.ops_task,
          action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
          operator: "and",
        },
        {
          url: urls.operation_task,
          lable: "Manage Tasks",
          Icon: <Icon path={mdiFormatListCheckbox} className="h-5 w-5 mx-2" />,
          module: MODULE.ops_ticket,
          action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
          operator: "and",
        },
        {
          url: urls.operation_engineer_task,
          lable: "My Tasks",
          Icon: <Icon path={mdiToolboxOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.ops_task,
          action: [ACTION.READ],
        },
        {
          url: urls.ops_task_session,
          lable: "Engineer Sessions",
          Icon: <Icon path={mdiCalendarClock} className="h-5 w-5 mx-2" />,
          module: MODULE.ops_ticket,
          action: [ACTION.READ],
        },
      ];
    case MODULE.api_inegration_panel:
      return [
        {
          url: urls.api_client_my_list,
          lable: "Api keys",
          Icon: <Icon path={mdiApi} className="h-5 w-5 mx-2" />,
          module: MODULE.api_master,
          action: [ACTION.READ],
        },
      ];
    case MODULE.content_panel:
      return [
        {
          url: urls.content_panel,
          lable: "Dashboard",
          Icon: <></>,
          module: MODULE.api_master,
          action: [ACTION.READ],
        },

        {
          url: urls.blogListing,
          lable: "Blogs",
          Icon: <Icon path={mdiPostOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.content,
          action: [ACTION.CREATE],
          operator: "or",
        },

        {
          lable: "Upload image",
          Icon: <Icon path={mdiTrayArrowUp} className="h-5 w-5 mx-2" />,
          url: urls.uploadImage,
          module: MODULE.content,
          action: [ACTION.CREATE],
          operator: "or",
        },

        {
          lable: "Installation collage",
          Icon: <Icon path={mdiCollage} className="h-5 w-5 mx-2" />,
          url: urls.installation,
          module: MODULE.content,
          action: [ACTION.CREATE],
          operator: "or",
        },
        {
          lable: "Case Study",
          Icon: <Icon path={mdiBook} className="h-5 w-5 mx-2" />,
          url: urls.case_study,
          module: MODULE.case_study,
          action: [ACTION.READ, ACTION.UPDATE],
          operator: "or",
        },
        {
          lable: "Blog Authors",
          Icon: <Icon path={mdiAccountGroup} className="h-5 w-5 mx-2" />,
          url: urls.authors,
          module: MODULE.content,
          action: [ACTION.CREATE],
          operator: "or",
        },
        {
          lable: "EV",
          Icon: <Icon path={mdiCar} className="h-5 w-5 mx-2" />,
          url: urls.ev,
          module: MODULE.content,
          action: [ACTION.READ, ACTION.UPDATE],
          operator: "and",
        },
      ];

    case MODULE.warehouse_panel:
      return [
        {
          url: urls.warehouse_dashboard,
          lable: "Dashboard",
          Icon: <Icon path={mdiViewDashboard} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_inward,
          lable: "Inward",
          Icon: (
            <Icon
              path={mdiPackageVariantClosedCheck}
              className="h-5 w-5 mx-2"
            />
          ),
          module: MODULE.warehouse_panel,
          action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
        },
        {
          url: urls.warehouse_panel + "/outward",
          lable: "Outward",
          Icon: <Icon path={mdiTruckOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_panel + "/stock-transfers",
          lable: "Stock Transfers",
          Icon: <Icon path={mdiSwapHorizontal} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_panel + "/finance",
          lable: "Finance",
          Icon: <Icon path={mdiCurrencyInr} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_inventory,
          lable: "Inventory",
          Icon: (
            <Icon path={mdiPackageVariantClosed} className="h-5 w-5 mx-2" />
          ),
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_stock_ledger,
          lable: "Stock Ledger",
          Icon: <Icon path={mdiBookOpenPageVariant} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_quarantine,
          lable: "Quarantine",
          Icon: <Icon path={mdiAlertOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_faulty_resolution,
          lable: "Faulty Resolution",
          Icon: <Icon path={mdiWrenchOutline} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_team,
          lable: "Team Management",
          Icon: (
            <Icon path={mdiAccountMultipleOutline} className="h-5 w-5 mx-2" />
          ),
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_panel,
          lable: "Warehouse Management",
          Icon: <Icon path={mdiWarehouse} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.warehouse_logs,
          lable: "Logs",
          Icon: <Icon path={mdiFileDocument} className="h-5 w-5 mx-2" />,
          module: MODULE.warehouse_panel,
          action: [ACTION.READ],
        },
      ];

    case MODULE.master_data_panel:
      return [
        {
          url: urls.procurement_masters_warehouse,
          lable: "Warehouse",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
        // Phase 6 — Dashboards entries. The Finance dashboard is EAF/L3-only;
        // the CC dashboard list is the user's CCs (visible to anyone with
        // cost_center.Read — SPOC, BU Head, Dept Head, EAF).
        {
          url: urls.matrix_dashboard,
          lable: "Master Dashboard",
          module: MODULE.eaf,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_dashboard,
          lable: "Procurement Metrics",
          module: MODULE.eaf,
          action: [ACTION.READ],
        },
        {
          url: urls.finance_dashboard,
          lable: "Finance Dashboard",
          module: MODULE.eaf,
          action: [ACTION.READ],
        },
        {
          url: urls.business_unit,
          lable: "Business Unit",
          module: MODULE.business_unit,
          action: [ACTION.READ],
        },
        {
          url: urls.department,
          lable: "Department",
          module: MODULE.department,
          action: [ACTION.READ],
        },
        // Phase 7C — EAF-only bulk cadence editor
        {
          url: urls.budget_cadence,
          lable: "Budget Cadence",
          module: MODULE.eaf,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_masters_cost_center,
          lable: "Cost Center",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_project,
          lable: "Project",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_masters_party,
          lable: "Vendor",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_masters_gst,
          lable: "Kazam GST",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_masters_item,
          lable: "Items",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_masters_item_unit,
          lable: "Item Units",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
        {
          url: urls.procurement_masters_transform,
          lable: "Transform Data",
          module: MODULE.master_data_panel,
          action: [ACTION.READ],
        },
      ];

    // Phase 8 — MIS module.
    case MODULE.mis_panel:
      return [
        {
          url: urls.mis_list,
          lable: "All MIS",
          Icon: <Icon path={mdiChartBar} className="h-5 w-5 mx-2" />,
          module: MODULE.mis_panel,
          action: [ACTION.READ],
        },
      ];

    case MODULE.procurement_panel:
      return [
        {
          url: urls.procurement,
          lable: "Home",
          module: MODULE.procurement_panel,
          action: [ACTION.READ],
        },
        {
          lable: "Purchase order",
          module: MODULE.purchase_order_self,
          action: [ACTION.READ],
          menu: [
            {
              url: urls.purchase_order,
              lable: "Purchase orders",
              // : <Icon path={mdiBox} className="h-5 w-5 mx-2" />,
              module: MODULE.purchase_order_self,
              action: [ACTION.READ],
            },
            {
              url: urls.purchase_order + "/approval",
              lable: "PO Approvals",
              module: MODULE.purchase_order_approval,
              action: [ACTION.READ],
            },
          ],
        },
        {
          lable: "Payment request",
          module: MODULE.purchase_order_self,
          action: [ACTION.READ],
          menu: [
            {
              url: urls.po_advance_payment_request,
              lable: "Payment Request",
              module: MODULE.payment_request_maker,
              action: [ACTION.READ, ACTION.UPDATE, ACTION.CREATE],
            },
            {
              url: urls.po_payment_request_approval,
              lable: "Payment Request approval",
              module: MODULE.payment_request_checker,
              action: [ACTION.READ, ACTION.UPDATE],
            },
          ],
        },
        {
          lable: "GRN",
          module: MODULE.voucher_self,
          action: [ACTION.READ],
          url: urls.purchase_voucher,
        },

        {
          lable: "SRN",
          module: MODULE.voucher_self,
          action: [ACTION.READ],
          url: urls.purchase_service_voucher,
        },

        /* Hidden from procurement sidebar: Sender, Receiver, In Transit, Stock Outward
        {
          lable: "Stock Transfer",
          module: MODULE.stock_transfer_journals,
          action: [ACTION.READ],
          menu: [
            {
              url: urls.stock_transfer,
              lable: "Sender",
              module: MODULE.stock_transfer_journals,
              action: [ACTION.READ],
            },
            {
              url: urls.stock_transfer + "/receiver",
              lable: "Receiver",
              module: MODULE.stock_transfer_journals,
              action: [ACTION.READ],
            },
            {
              url: urls.stock_transfer + "/in-transit",
              lable: "In Transit",
              module: MODULE.stock_transfer_journals,
              action: [ACTION.READ],
            },
          ],
        },
        {
          lable: "Stock Outward",
          module: MODULE.stock_outward,
          action: [ACTION.READ],
          menu: [
            {
              url: urls.stock_outward,
              lable: "Stock Outward",
              module: MODULE.stock_outward,
              action: [ACTION.READ],
            },
          ],
        },
        */
        {
          lable: "NPD",
          module: MODULE.procurement_master,
          action: [ACTION.READ],
          url: urls.npd,
        },
        {
          lable: "Report Viewer",
          url: urls.procurement_masters_po_report,
          module: MODULE.procurement_panel,
          action: [ACTION.READ],
        },
        {
          lable: "Previous Masters",
          module: MODULE.procurement_master,
          action: [ACTION.READ],
          menu: [
            {
              url: urls.purchase_order_prev,
              lable: "Purchase Order Previous",
              module: MODULE.procurement_master,
              action: [ACTION.READ],
            },
            {
              url: urls.project_master,
              lable: "Project",
              module: MODULE.procurement_master,
              action: [ACTION.READ],
            },
            {
              url: urls.procurement_masters_party_prev,
              lable: "Vendor",
              module: MODULE.procurement_master,
              action: [ACTION.READ],
            },
            {
              url: urls.procurement_masters_item_prev,
              lable: "Items",
              module: MODULE.procurement_master,
              action: [ACTION.READ],
            },
            {
              lable: "Previous Payment Requests",
              module: MODULE.purchase_order_self,
              action: [ACTION.READ],
              menu: [
                {
                  url: urls.po_advance_payment_request_prev,
                  lable: "Payment Request",
                  module: MODULE.payment_request_maker,
                  action: [ACTION.READ, ACTION.UPDATE, ACTION.CREATE],
                },
                {
                  url: urls.po_payment_request_approval_prev,
                  lable: "Payment Request approval",
                  module: MODULE.payment_request_checker,
                  action: [ACTION.READ, ACTION.UPDATE],
                },
              ],
            },
          ],
        },
      ];
    case MODULE.dashboard:
      return [
        {
          url: urls.Dashboard,
          lable: "All Dashboards",
          Icon: <Icon path={mdiHome} className="h-5 w-5 mx-2" />,
          action: [ACTION.READ],
        },
      ];
    default:
      return [];
  }
};
